// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore} from "firebase/firestore";
import { getAuth } from 'firebase/auth'; 
//import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBhowzdhK6NbIcaQ9nTyrhZVnsbyulOpok",
  authDomain: "dictionary-game-379f6.firebaseapp.com",
  projectId: "dictionary-game-379f6",
  storageBucket: "dictionary-game-379f6.firebasestorage.app",
  messagingSenderId: "1092999374671",
  appId: "1:1092999374671:web:57f4111607656c9816473a",
  measurementId: "G-DH1JLJK4WE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
//const analytics = getAnalytics(app);